// extracted by mini-css-extract-plugin
module.exports = {"container":"style-module_container__expfbt52GfYk75clayqZK","name":"style-module_name__1MPTOGtL3NqMt-KOziLAbP","description":"style-module_description__3zQNlwGZ7VwMBGeBTxnaVo"};